import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  promoTypeShown: null
}

const slice = createSlice({
  name: 'extensionPromo',
  initialState,
  reducers: {
    setPromoTypeShown: (state, { payload }) => {
      state.promoTypeShown = payload
    }
  }
})

export const { reducer, actions: { setPromoTypeShown } } = slice
